export function userLogin(email, password, next) {
  return {
    type: 'USER_LOGIN_REQUESTED',
    email,
    password,
    next,
  };
}

export function userLogout() {
  return {
    type: 'USER_LOGOUT_REQUESTED',
  };
}

export function userSignup(email, password) {
  return {
    type: 'USER_SIGNUP_REQUESTED',
    email,
    password,
  };
}

export function getUserByToken(token) {
  return {
    type: 'GET_USER_BY_TOKEN_REQUESTED',
    token,
  };
}

export function restoreUserByToken(next) {
  return {
    type: 'RESTORE_USER_BY_TOKEN_REQUESTED',
    next,
  };
}

export function resetPassword(email) {
  return {
    type: 'PASSWORD_RESET_REQUESTED',
    email,
  };
}

export function changePassword(currentPassword, newPassword) {
  return {
    type: 'PASSWORD_CHANGE_REQUESTED',
    currentPassword,
    newPassword,
  };
}

export function getConferences() {
  return {
    type: 'CONFERENCES_REQUESTED',
  };
}

export function getAdminConferences() {
  return {
    type: 'ADMIN_CONFERENCES_REQUESTED',
  };
}

export function getConference(conferenceId) {
  return {
    type: 'CONFERENCE_PROFILE_REQUESTED',
    conferenceId,
  };
}

export function editConference(conferenceId) {
  return {
    type: 'CONFERENCE_EDIT_REQUESTED',
    conferenceId,
  };
}

export function deleteConference(conferenceId) {
  return {
    type: 'CONFERENCE_DELETE_REQUESTED',
    conferenceId,
  };
}

export function cloneConference(conferenceId) {
  return {
    type: 'CONFERENCE_CLONE_REQUESTED',
    conferenceId,
  };
}

export function getApplications(conferenceId) {
  return {
    type: 'CONFERENCE_APPLICATIONS_REQUESTED',
    conferenceId,
  };
}

export function getApplication(conferenceId) {
  return {
    type: 'CONFERENCE_APPLICATION_REQUESTED',
    conferenceId,
  };
}

export function applyForConference(conferenceId, userData, formAnswers, selectedTickets, paymentType) {
  return {
    type: 'CONFERENCE_APPLY_REQUESTED',
    conferenceId,
    userData,
    formAnswers,
    selectedTickets,
    paymentType,
  };
}

export function paymentCheck(conferenceId, search) {
  return {
    type: 'CONFERENCE_PAYMENTCALLBACK_REQUESTED',
    conferenceId,
    search,
  };
}

export function paymentCheckOtp(conferenceId, search) {
  return {
    type: 'CONFERENCE_PAYMENTCALLBACK_OTP_REQUESTED',
    conferenceId,
    search,
  };
}

export function paymentCheckKhSzep(tix) {
  return {
    type: 'CONFERENCE_PAYMENTCALLBACK_KHSZEP_REQUESTED',
    tix,
  };
}

export function cancelApplication(conferenceId, redirect) {
  return {
    type: 'CONFERENCE_CANCEL_APPLY_REQUESTED',
    conferenceId,
    redirect,
  };
}

export function createWebExport(conferenceId) {
  return {
    type: 'CONFERENCE_CREATE_WEBEXPORT_REQUESTED',
    conferenceId,
  };
}

export function getInfoTexts() {
  return {
    type: 'TEXTINFOS_GET_INFO_TEXTS_REQUESTED',
  };
}

export function getInfoText(permalink) {
  return {
    type: 'TEXTINFOS_GET_INFO_TEXT_REQUESTED',
    permalink,
  };
}

export function listInfoTexts() {
  return {
    type: 'TEXTINFOS_LIST_INFO_TEXTS_REQUESTED',
  };
}

export function toggleTextinfoModal(modalIsVisible) {
  return {
    type: 'TEXTINFOS_TOGGLE_MODAL',
    modalIsVisible,
  };
}

export function changeInfotextField(fieldId, value) {
  return {
    type: 'TEXTINFOS_CHANGE_FIELD',
    fieldId,
    value,
  };
}

export function editInfotextRow(row) {
  return {
    type: 'TEXTINFOS_EDIT_INFOTEXT_ROW',
    row,
  };
}

export function deleteInfotextRow(rowId) {
  return {
    type: 'TEXTINFOS_DELETE_INFOTEXT_ROW',
    rowId,
  };
}

export function toggleInfotextRow(rowId, isVisible) {
  return {
    type: 'TEXTINFOS_TOGGLE_INFOTEXT_ROW',
    rowId,
    isVisible,
  };
}

export function setTextInfo(actionType) {
  return {
    type: 'TEXTINFOS_CREATE_TEXTINFO_REQUESTED',
    actionType,
  };
}

export function repay(conferenceId, paymentType) {
  return {
    type: 'CONFERENCE_PAYMENT_REPAY',
    conferenceId,
    paymentType,
  };
}

export function getBillingInfo() {
  return {
    type: 'FETCH_BILLING_INFO',
  };
}

export function updateBillingInfo(values) {
  return {
    type: 'SAVE_BILLING_INFO',
    values,
  };
}

export function createInvoice(applicationId) {
  return {
    type: 'CREATE_APPLICATION_INVOICE',
    applicationId,
  };
}

export function downloadInvoice(invoiceNo) {
  return {
    type: 'DOWNLOAD_APPLICATION_INVOICE',
    invoiceNo,
  };
}



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/actions/actions.js